import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { ProjectAreaOfFocus } from '../../entities/project-area-of-focus';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class ProjectAreaOfFocusService {

  private static readonly projectAreaOfFocusBaseUrl:string = `${Settings.apiUrl}/v1/ProjectAreasOfFocus`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  public projectAreasOfFocus:ProjectAreaOfFocus[] = [];

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getProjectAreasOfFocus():Promise<ProjectAreaOfFocus[]>{

    return this.cachedCallService.invokeSingleCall(
      () => {
        let oDataBuilder:ODataBuilder = new ODataBuilder(ProjectAreaOfFocusService.projectAreaOfFocusBaseUrl);

        //TODO:  Add sort order?
        // oDataBuilder
        //   .orderBy("SortOrder");

        let projectAreaOfFocusUrl:string = oDataBuilder.toString();

        return this.http.get(projectAreaOfFocusUrl)
                .toPromise()
                .then(response => {
                  this.projectAreasOfFocus = response.json().value;

                  return this.projectAreasOfFocus;
                });
      }, "getProjectAreasOfFocus"
    );
    
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/project-area-of-focus.service.ts